// 環境配置
// 根據 NODE_ENV 和 REACT_APP_ENV 來區分本地和線上環境

const isDevelopment = process.env.NODE_ENV === 'development';

// 優先使用 REACT_APP_ENV，如果沒有則根據 NODE_ENV 判斷
// 開發模式默認使用 local，生產模式默認使用 production
const envType = process.env.REACT_APP_ENV || (isDevelopment ? 'local' : 'production');

// 本地開發環境配置
const localConfig = {
  basename: '/admin',
};

// 線上生產環境配置
const productionConfig = {
  basename: '/',
};

// 根據環境選擇配置
const getConfig = () => {
  if (envType === 'local' || envType === 'development') {
    return localConfig;
  }
  return productionConfig;
};

const config = getConfig();

export default config;
export const BASENAME = config.basename;

